module.exports = __webpack_public_path__ + "static/media/santa_maria.32b9ce36.png";